export default {
  methods: {
    removeUrlTrailingSlash(url) {
      if (!url) return;
      return url.trim().replace(/\/$/, '');
    },
    assignURLToCurrentTab(url) {
      window.location.assign(url);
    },
    openURLInNewTab(url) {
      window.open(url, '_blank');
    },
    isValidImageURL(url, supportTypes) {
      if (!url) return false;
      const regex = new RegExp(`^(?:(?:https?|ftp):\\/\\/)?(?://([^/?#]*))?([^?#]*\\.(?:${supportTypes.join('|')}))(?:\\?([^#]*))?(?:#(.*))?`, 'i');
      return regex.test(url);
    },
  },
};
